import api from 'Application/api/api';

const updateProjectWorkingHours = (projectId, data, cancelToken = null) =>
    api.post(`project-manager/projects/${projectId}/working-hours`, data, {
        cancelToken,
    });

export default updateProjectWorkingHours;
